import React from "react";
import { ArrowUp } from "lucide-react";
import { cn } from "@/lib/utils";
import usePostHeroVisibility from "./usePostHeroVisibility";

export const ScrollToTop = () => {
  const visible = usePostHeroVisibility();

  const reduce =
    typeof window !== "undefined" &&
    window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: reduce ? "auto" : "smooth" });
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      aria-label="Volver arriba"
      data-testid="scroll-to-top"
      tabIndex={visible ? 0 : -1}
      aria-hidden={!visible}
      className={cn(
        "fixed bottom-32 right-6 z-40 inline-flex h-11 w-11 items-center justify-center rounded-full border border-[hsl(var(--cyan))]/30 bg-[hsl(var(--navy))] text-white shadow-glow transition-all duration-300 hover:border-[hsl(var(--cyan))]/60 hover:bg-[hsl(var(--navy-2))] focus-ring sm:bottom-36 sm:right-8",
        visible
          ? "pointer-events-auto translate-y-0 opacity-100"
          : "pointer-events-none translate-y-3 opacity-0"
      )}
    >
      <ArrowUp className="h-4 w-4" />
    </button>
  );
};

export default ScrollToTop;